// extracted by mini-css-extract-plugin
export default {"panel":"Subcutanea_panel__uIC+V","subHeader":"Subcutanea_subHeader__2kQ0+","sectionHeader":"Subcutanea_sectionHeader__FH2Cy"};